export default function rateMarkPercentFilter(mark: number | null | '') {
  if (mark === null || mark === '') {
    return ''
  }

  /**
   * Добавляется 0.000001, так как возможны ошибки при вычислениях для чисел с плавающей точкой. Например:
   * (-1.6 + 2) * 25 вычисляется как 9.999999999999998, а не 10, из-за чего Math.floor возвращает не то число.
   */
  return Math.floor((mark + 2) * 25 + 0.000001) || 1
}
